import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
import './Login.css'
// import LoginBanner from '../../assets/images/login-banner.svg'
import LoginBanner from '../../assets/images/welcome-image.png'
import Logo from '../../assets/images/logo.png'
import global from '../../config'

export default function LoginPage(props) {
    const navigate = useNavigate();

    const [toggleLoginSignupBlock, setToggleLoginSignup] = useState('false')
    const [activeForgotPassword, setActiveForgotPassword] = useState('false')
    const [loginEmailError, setLoginEmailError]=useState(false)
    const [loginPasswordError, setLoginPasswordError]=useState(false)
    const [valEmail, setValEmail]=useState('')
    const [valPassword, setValPassword]=useState('')
    const [loginError, setLoginError]=useState(false)

    const loginClick=async ()=>{
        if(valEmail.trim()===''){
            setLoginEmailError(true)
        }
        if(valPassword.trim()===''){
            setLoginPasswordError(true)
        }

        const loginPayLoad = { username: valEmail, password:valPassword };
        try{
            const response=await axios.post(global.apiURL+'/user/login', loginPayLoad);
            const tokenDetails=response?.data?.data?.AuthenticationResult;
            if(response && response.status===200 && tokenDetails.IdToken){
                localStorage.setItem('idToken', tokenDetails.IdToken);
                localStorage.setItem('accessToken', tokenDetails.AccessToken);
                localStorage.setItem('refreshToken', tokenDetails.RefreshToken);
                localStorage.setItem('expiresIn', tokenDetails.ExpiresIn);
                localStorage.setItem('tokenType', tokenDetails.TokenType);

                navigate('/admin/shows');
            }
            else{
                console.log("Login Error")
                setLoginError(true)
            }
        }
        catch(e){
            console.log("Invalid Login Credentials")
            setLoginError(true)
        }
    }


    const txtValue=(e)=>{
        if(e.target.name==='txtEmail'){
            setValEmail(e.target.value)
            if(e.target.value.trim()===''){
                setLoginEmailError(true)
            }
            else{
                setLoginEmailError(false)
            }
        }
        else if(e.target.name==='txtPassword'){
            setValPassword(e.target.value)
            if(e.target.value.trim()===''){
                setLoginPasswordError(true)
            }
            else{
                setLoginPasswordError(false)
            }
        }
    }

    useEffect(() => {
        async function verifyUser() {
            const idToken=localStorage.getItem('idToken');
            if(idToken){
                navigate('/admin/shows');
            }
        }
        verifyUser()

    }, [])
    
    const gotToHome=()=>{
        navigate('/')
    }

    return(
        <div className='login-container'>
            <div className='login-left'>
                <div className='login-block'>
                    {/* <h1 className='welcome-text'>SIM Asset Management System</h1>
                    <p>Manage Shows & Creators</p> */}
                    <img src={LoginBanner} alt="SIM Asset Management System" width={`90%`} />
                </div>
            </div>
            <div className='login-right'>
                {activeForgotPassword ? 
                <>
                    {toggleLoginSignupBlock ?
                        <div className='login-block-right'>
                            <img src={Logo} alt="SIM Asset Management System" height={'100px'}  onClick={()=>gotToHome()}/>
                            <h2>Login</h2>
                            <p>SIM Asset Management System</p>
                            <div className='form-group-area'>
                                <label>Email address <span className='required'>*</span></label>
                                <input onChange={txtValue} type='text' name='txtEmail' placeholder='E-mail' autoComplete='off' />
                                {loginEmailError===true && <p className='error'>Enter Email Address</p> }
                            </div>
                            <div className='form-group-area'>
                                <label>Password <span className='required'>*</span></label>
                                <input onChange={txtValue} type='password' name='txtPassword' placeholder='Password' />
                                {loginPasswordError===true && <p className='error'>Enter your password</p>}
                            </div>
                            <div className='form-group-area'>
                                <div className='form-group-row'>
                                    <div className='form-group-col'>
                                        {loginError===true && <p className='error'>Invalid Login Details</p> }
                                    </div>
                                  
                                </div>
                            </div>
                            <div className='form-group-area'>
                                <button type='button' className='login-submit' onClick={loginClick} >Login</button>
                            </div>
                        </div>
                        :
                        <></>
                    }
                </>
                :
                <div className='login-block-right'>
                    <h2>Forgot your Password?</h2>
                    <p>Enter your details</p>
                    <div className='form-group-area'>
                        <label>Email address <span className='required'>*</span></label>
                        <input type='text' placeholder='E-mail' />
                        <p className='error'>Enter Email Address</p>
                    </div>
                    <div className='form-group-area'>
                        <button type='button' className='login-submit'>Submit</button>
                    </div>
                </div>
                }
            </div>
        </div>
    )
}